import { observable, action, computed } from 'mobx';
import GuestCandidateModel from '~/glm/models/shared/guest-import/guest-candidate-model';

class GuestCandidateCollection {
  static initialGuestCount = 100; // corresponds to # of rows in new spreadsheet
  @observable guests = [];

  constructor(initialGuestCount = GuestCandidateCollection.initialGuestCount) {
    this.initialGuestCount = initialGuestCount;
    this.reset();
  }

  @action
  clear() {
    this.guests.clear();
  }

  @action
  add(guest) {
    this.guests.push(guest);
  }

  @action
  updateGuest(rowId, props) {
    Object.assign(this.guests[rowId], props);
  }

  @action
  remove(guest) {
    this.guests.remove(guest);
  }

  @action
  reset() {
    this.guests.clear();
    for (let i = 0; i < this.initialGuestCount; i += 1) {
      this.guests.push(new GuestCandidateModel());
    }
  }

  find(func) {
    return this.guests.find(func);
  }

  @computed
  get count() {
    return this.allGuests.length;
  }

  @computed
  get validCount() {
    return this.validGuests.length;
  }

  @computed
  get validGuests() {
    return this.guests.filter(guest => guest.isValid);
  }

  @computed
  get allGuests() {
    return this.guests.filter(guest => guest.isNotEmpty);
  }

  validateFields(...fields) {
    return !![...fields].find(field => !this.allGuests.find(guest => !guest.validateField(field)));
  }

  @computed
  get isValid() {
    return this.count === this.validCount;
  }

  @action
  insertPastedSpreadsheet(string, originRowID, originColID) {
    const rows = GuestCandidateCollection.parseSpreadsheet(string);
    let curRow = parseInt(originRowID, 10);
    const pastedResult = {};
    let count = 0;
    let errors = 0;
    rows.forEach(row => {
      if (curRow >= this.guests.length) this.guests.push(new GuestCandidateModel());
      count += 1;
      pastedResult.row = curRow;
      let curCol = parseInt(originColID, 8);
      row.some(column => {
        if (curCol < GuestCandidateModel.TABLE_COLUMN_MAPPING.length) {
          const field = GuestCandidateModel.TABLE_COLUMN_MAPPING[curCol];
          this.guests[curRow][field.apiName] = column;
          if (column) {
            pastedResult.column = curCol;
          }

          curCol += 1;
          return false;
        }
        return true;
      });
      if (!this.guests[curRow].isValid) {
        errors += 1;
      }
      curRow += 1;
    });
    pastedResult.count = count;
    pastedResult.errors = errors;
    return pastedResult;
  }

  static parseSpreadsheet(string) {
    const rowsArray = [];
    const rows = string.split(/\n/);

    rows.forEach(row => {
      rowsArray.push(row.split(/\t/));
    });

    return rowsArray;
  }
}

export default GuestCandidateCollection;
